import React from 'react'

const FundHouse = () => {
  return (
    <div>FundHouse</div>
  )
}

export default FundHouse